export const isLinkedToObligation = task => !!(
  task?.complianceObligation ||
  task?.metadata?.programmeObligationId ||
  task?.metadata?.programme_obligation_id
)

export const approveConfirmOptions = task => ({
  title: 'Approve this task?',
  message: isLinkedToObligation(task)
    ? 'It will be marked as completed and counts towards the compliance obligation.'
    : 'It will be marked as completed.',
  confirmLabel: 'Approve',
  tone: 'primary'
})
